module.exports = __webpack_public_path__ + "static/media/logo-white-big.04fab734.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/logo-white-big.png
 ** module id = 592
 ** module chunks = 0
 **/